import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { inputBorderColor } from '../../../../styles/colors';

const { common } = THEME;

export const styleSheet = StyleSheet.create({
	dropdownContentInnerOverrides: {
		// inputBorderColor (#CCCCCC) has no exact THEME token; retained to match the other filter dropdowns.
		borderColor: inputBorderColor,
		borderBottomLeftRadius: common.borderRadius,
		borderBottomRightRadius: common.borderRadius,
		borderTopRightRadius: 0,
		maxHeight: '700px !important',
	},
	dropdownMenuOverrides: {
		maxHeight: '700px !important',
	},
});
